export default __webpack_public_path__ + "static/media/currencyEx.a6b5f669.png";